import { modes } from '@powerplay/common';
import { TypeEvents } from './types';
import { inputSchema } from './config';
export class InputsManager {
    tutorialActionPressedCallback;
    callbackLeft;
    callbackRight;
    callbackUp;
    callbackDown;
    callbackAction;
    callbackUpdate;
    callbackPrepareVideo;
    callbackAction2;
    callbackAction3;
    callbackExit;
    actionPressed = 0;
    actionInputsBlocked = false;
    inputSchemaDecision;
    constructor(tutorialActionPressedCallback) {
        this.tutorialActionPressedCallback = tutorialActionPressedCallback;
    }
    init(callbacksInputs, callbackUpdate, inputSchemaDecision = 'default') {
        const { callbackLeft, callbackRight, callbackUp, callbackDown, callbackAction } = callbacksInputs;
        this.callbackLeft = callbackLeft;
        this.callbackRight = callbackRight;
        this.callbackUp = callbackUp;
        this.callbackDown = callbackDown;
        this.callbackAction = callbackAction;
        this.callbackUpdate = callbackUpdate;
        this.inputSchemaDecision = inputSchemaDecision;
        if (callbacksInputs.callbackPrepareVideo !== undefined) {
            this.callbackPrepareVideo = callbacksInputs.callbackPrepareVideo;
        }
        if (callbacksInputs.callbackAction2) {
            this.callbackAction2 = callbacksInputs.callbackAction2;
        }
        if (callbacksInputs.callbackAction3) {
            this.callbackAction3 = callbacksInputs.callbackAction3;
        }
        if (callbacksInputs.callbackExit) {
            this.callbackExit = callbacksInputs.callbackExit;
        }
        window.addEventListener('keydown', this.handleKeyDown, false);
        window.addEventListener('keyup', this.handleKeyUp, false);
        window.addEventListener('mousedown', this.handleMouseDown);
        window.addEventListener('mouseup', this.handleMouseUp);
        window.addEventListener('touchstart', this.handleMouseDown);
        window.addEventListener('touchend', this.handleMouseUp);
    }
    handleKeyDown = (event) => {
        this.handleKey(TypeEvents.down, event);
    };
    handleKeyUp = (event) => {
        this.handleKey(TypeEvents.up, event);
    };
    handleMouseDown = () => {
        this.onKeyAction(TypeEvents.down);
    };
    handleMouseUp = () => {
        this.onKeyAction(TypeEvents.up);
    };
    handleKey(type, event) {
        if (event.key) {
            this.handleKeyNewWay(event.key, type);
        }
        else if (event.keyCode) {
            this.handleKeyOldWay(event.keyCode, type);
        }
        else {
            throw new Error('Handle key error');
        }
    }
    handleKeyNewWay(key, type) {
        const lowerCasekey = key.toLocaleLowerCase();
        if (inputSchema[this.inputSchemaDecision]
            .new
            .keyup
            .includes(lowerCasekey))
            this.onKeyUp(type);
        if (inputSchema[this.inputSchemaDecision]
            .new
            .keydown
            .includes(lowerCasekey))
            this.onKeyDown(type);
        if (inputSchema[this.inputSchemaDecision]
            .new
            .keyleft
            .includes(lowerCasekey))
            this.onKeyLeft(type);
        if (inputSchema[this.inputSchemaDecision]
            .new
            .keyright
            .includes(lowerCasekey))
            this.onKeyRight(type);
        if (inputSchema[this.inputSchemaDecision]
            .new
            .keyaction
            .includes(lowerCasekey))
            this.onKeyAction(type);
        if (inputSchema[this.inputSchemaDecision]
            .new
            .keyexit
            .includes(lowerCasekey))
            this.onKeyExit(type);
        if (this.inputSchemaDecision === 'biathlon') {
            if (inputSchema[this.inputSchemaDecision]
                .new
                .keyaction2
                .includes(lowerCasekey))
                this.onKeyAction2(type);
            if (inputSchema[this.inputSchemaDecision]
                .new
                .keyaction3
                .includes(lowerCasekey))
                this.onKeyAction3(type);
        }
        if (this.inputSchemaDecision === 'giantSlalom') {
            if (inputSchema[this.inputSchemaDecision]
                .new
                .keyaction2
                .includes(lowerCasekey))
                this.onKeyAction2(type);
        }
        if (type === TypeEvents.down) {
            if (['p'].includes(lowerCasekey))
                this.callbackUpdate();
            if (['*'].includes(lowerCasekey))
                this.callbackPrepareVideo();
        }
    }
    handleKeyOldWay(keyCode, type) {
        if (inputSchema[this.inputSchemaDecision]
            .old
            .keyup
            .includes(keyCode))
            this.onKeyUp(type);
        if (inputSchema[this.inputSchemaDecision]
            .old
            .keydown
            .includes(keyCode))
            this.onKeyDown(type);
        if (inputSchema[this.inputSchemaDecision]
            .old
            .keyleft
            .includes(keyCode))
            this.onKeyLeft(type);
        if (inputSchema[this.inputSchemaDecision]
            .old
            .keyright
            .includes(keyCode))
            this.onKeyRight(type);
        if (inputSchema[this.inputSchemaDecision]
            .old
            .keyaction
            .includes(keyCode))
            this.onKeyAction(type);
        if (inputSchema[this.inputSchemaDecision]
            .old
            .keyexit
            .includes(keyCode))
            this.onKeyExit(type);
        if (this.inputSchemaDecision === 'biathlon') {
            if (inputSchema[this.inputSchemaDecision]
                .old
                .keyaction2
                .includes(keyCode))
                this.onKeyAction2(type);
            if (inputSchema[this.inputSchemaDecision]
                .old
                .keyaction3
                .includes(keyCode))
                this.onKeyAction3(type);
        }
        if (type === TypeEvents.down) {
            if ([80].includes(keyCode))
                this.callbackUpdate();
            if ([106].includes(keyCode))
                this.callbackPrepareVideo();
        }
    }
    onKeyUp(type) {
        this.callbackUp(type);
    }
    onKeyDown(type) {
        this.callbackDown(type);
    }
    onKeyLeft(type) {
        this.callbackLeft(type);
    }
    onKeyRight(type) {
        this.callbackRight(type);
    }
    onKeyAction(type) {
        if (this.actionInputsBlocked)
            return;
        if (this.callbackAction) {
            this.callbackAction(type);
            this.actionPressed = type - 1;
            if (type === TypeEvents.down)
                this.tutorialAction();
        }
    }
    onKeyAction2(type) {
        if (this.actionInputsBlocked)
            return;
        if (this.callbackAction2) {
            this.callbackAction2(type);
            this.actionPressed = type - 1;
            if (type === TypeEvents.down)
                this.tutorialAction();
        }
    }
    onKeyAction3(type) {
        if (this.actionInputsBlocked)
            return;
        if (this.callbackAction3) {
            this.callbackAction3(type);
            this.actionPressed = type - 1;
            if (type === TypeEvents.down)
                this.tutorialAction();
        }
    }
    onKeyExit(type) {
        if (this.callbackExit) {
            this.callbackExit(type);
        }
    }
    tutorialAction() {
        if (!modes.isTutorial())
            return;
        this.tutorialActionPressedCallback?.();
    }
}
//# sourceMappingURL=InputsManager.js.map